import { render, staticRenderFns } from "./BlogTwo.vue?vue&type=template&id=3bbdd20f&"
import script from "./BlogTwo.vue?vue&type=script&lang=js&"
export * from "./BlogTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bbdd20f')) {
      api.createRecord('3bbdd20f', component.options)
    } else {
      api.reload('3bbdd20f', component.options)
    }
    module.hot.accept("./BlogTwo.vue?vue&type=template&id=3bbdd20f&", function () {
      api.rerender('3bbdd20f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/blogs/BlogTwo.vue"
export default component.exports